import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Seo } from '../components/Seo';
import { findPost } from '../data/blog';

export function BlogPost() {
  const { t } = useTranslation();
  const { slug = '' } = useParams();
  const post = findPost(slug);

  if (!post) {
    return (
      <section className="section">
        <h1 className="text-3xl font-black">{t('blog:articleNotFound')}</h1>
      </section>
    );
  }

  return (
    <>
      <Seo title={`${post.title} | GyroNavi`} description={post.excerpt} path={`/blog/${post.slug}`} />
      <article className="section max-w-3xl">
        <h1 className="text-4xl font-black leading-tight text-ink">{post.title}</h1>
        <p className="mt-3 text-slate-500">{post.date} · {post.meta}</p>

        <div className="mt-8 space-y-8">
          {post.sections.map((section, index) => (
            <section key={index}>
              {section.heading ? <h2 className="text-2xl font-black text-ink">{section.heading}</h2> : null}
              {section.subheading ? <h3 className="mt-5 text-xl font-bold text-ink">{section.subheading}</h3> : null}
              {section.paragraphs?.map((paragraph) => (
                <p key={paragraph} className="mt-3 leading-8 text-slate-700">
                  {paragraph}
                </p>
              ))}
              {section.items?.length ? (
                <ul className="mt-3 space-y-2">
                  {section.items.map((item) => (
                    <li key={item} className="flex gap-2 leading-7 text-slate-700">
                      <span className="text-aqua">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              ) : null}
            </section>
          ))}
        </div>
      </article>
    </>
  );
}
